app.controller('ArticleSlickController',
	["$scope", function($scope) {
		$scope.slickBreakpoints = [
			{
				breakpoint: 900,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2
				}
			},{
				breakpoint: 640,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}
		];
	}]
);